import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Row, Col, FormGroup, Button, Label, Input } from 'reactstrap';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { color } from '~/assets/styles/colors';
import * as ActionsAuth from '~/store/modules/auth/actions';
import ReactGA from 'react-ga4';
import { Text } from "../Text";
import { ButtonArea } from './styles';

function AlterarSenha(props) {
	const { tokenUrl, reset } = props;
	const { user } = useSelector((state) => state.auth);
	const [senha, setSenha] = useState({
		atual: '',
		nova: '',
		confirmar: '',
		regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[#$@!%&*?_])(?=.*[0-9])[A-Za-z\d#$@!%&*?_]*$/,
	});

	const dispatch = useDispatch();
	const [diferente, setDiferente] = useState(false);
	const [maior8, setMaior8] = useState(false);
	const [confirmada, setConfirmada] = useState(false);
	const [alfanumerico, setAlfanumerico] = useState(false);

	function handleClickAlterarSenhaGA4() {
		ReactGA.event({
			category: "alterar_senha_click",
			action: "Alterar Senha",
			label: "Alterando Senha",
		});
	}

	function handlerPassword(input) {
		setSenha({ ...senha, nova: input.value });

		if (input.value !== '') {
			if (input.value !== senha.atual && senha.atual !== '') {
				setDiferente(true);
			} else {
				setDiferente(false);
			}

			if (input.value.length > 8) {
				setMaior8(true);
			} else {
				setMaior8(false);
			}

			if (senha.regex.test(input.value)) {
				setAlfanumerico(true);
			} else {
				setAlfanumerico(false);
			}
		} else {
			setDiferente(false);
			setMaior8(false);
			setAlfanumerico(false);
		}
	}

	function handlerConfirmPassword(input) {
		setSenha({ ...senha, confirmar: input.value });

		if (input.value !== '') {
			if (input.value === senha.nova) {
				setConfirmada(true);
			} else {
				setConfirmada(false);
			}
		} else {
			setConfirmada(false);
		}
	}

	function handlerSalvar() {
		if (maior8 && alfanumerico && confirmada) {
			if (reset) {
				dispatch(
					ActionsAuth.requestAlterarSenhaToken({
						token: tokenUrl,
						new_password: senha.nova,
					})
				);
			} else {
				dispatch(
					ActionsAuth.requestAlterarSenha({
						token: user.token.access,
						new_password: senha.nova,
					})
				);
			}
			handleClickAlterarSenhaGA4();
		} else {
			toast.error('Preencha corretamente todos os campos');
		}
	}

	return (
		<Row>
			<Col lg="6">
				{!reset && (
					<FormGroup className="pb-2">
						<Label>Digite sua senha atual</Label>
						<Input
							id="senhaAtual"
							type="password"
							placeholder="Digite aqui"
							onChange={(elemento) =>
								setSenha({
									...senha,
									atual: elemento.target.value,
								})
							}
						/>
					</FormGroup>
				)}
				<FormGroup className="pb-2">
					<Label>Digite sua nova senha</Label>
					<Input
						id="senhaNova"
						type="password"
						placeholder="Digite aqui"
						onChange={(input) => handlerPassword(input.target)}
					/>
				</FormGroup>
				<FormGroup>
					<Label>Confirme sua nova senha</Label>
					<Input
						id="senhaConfirmada"
						type="password"
						placeholder="Digite aqui"
						onChange={(input) =>
							handlerConfirmPassword(input.target)
						}
					/>
				</FormGroup>
			</Col>
			<Col lg="6">
				<Text color="black">Requisitos:</Text>
				{!reset && (
					<div className="d-flex align-items-center my-2">
						{diferente ? (
							<CheckBox
								className="mr-3"
								style={{
									color: `${color.primary}`,
								}}
							/>
						) : (
							<CheckBoxOutlineBlank
								className="mr-3"
								style={{
									color: `${color.grayMedium}`,
								}}
							/>
						)}

						<Text color={diferente ? '' : 'grayMedium'}>
							A nova senha deve ser diferente da anterior
						</Text>
					</div>
				)}
				<div className="d-flex align-items-center my-2">
					{maior8 ? (
						<CheckBox
							className="mr-3"
							style={{
								color: `${color.primary}`,
							}}
						/>
					) : (
						<CheckBoxOutlineBlank
							className="mr-3"
							style={{
								color: `${color.grayMedium}`,
							}}
						/>
					)}
					<Text color={maior8 ? '' : 'grayMedium'}>
						A nova senha deve ter no mínimo 8 dígitos
					</Text>
				</div>
				<div className="d-flex align-items-center my-2">
					{alfanumerico ? (
						<CheckBox
							className="mr-3"
							style={{
								color: `${color.primary}`,
							}}
						/>
					) : (
						<CheckBoxOutlineBlank
							className="mr-3"
							style={{
								color: `${color.grayMedium}`,
							}}
						/>
					)}
					<Text color={alfanumerico ? '' : 'grayMedium'}>
						Deve conter no mínimo 1 número, 1 letra maiúscula, e 1
						caractere especial
					</Text>
				</div>
				<div className="d-flex align-items-center mb-4">
					{confirmada ? (
						<CheckBox
							className="mr-3"
							style={{
								color: `${color.primary}`,
							}}
						/>
					) : (
						<CheckBoxOutlineBlank
							className="mr-3"
							style={{
								color: `${color.grayMedium}`,
							}}
						/>
					)}
					<Text color={confirmada ? '' : 'grayMedium'}>
						Senha confirmada com sucesso!
					</Text>
				</div>
			</Col>
			<ButtonArea className="d-flex justify-content-center">
				<Button color="primary" className="buttonComponent" onClick={() => handlerSalvar()}>
					SALVAR NOVA SENHA
				</Button>
			</ButtonArea>
		</Row>
	);
}

export default AlterarSenha;
